import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=63c01734&scoped=true"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"
import style0 from "./Advantage.vue?vue&type=style&index=0&id=63c01734&prod&scoped=true&lang=css"
import style1 from "./Advantage.vue?vue&type=style&index=1&id=63c01734&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c01734",
  null
  
)

export default component.exports